// Import props.
import { SvgIconProps } from '@mui/material/SvgIcon';
// Import enumerations.
import {
	BroadLineOfBusiness,
	Peril,
} from '@app/enumerations';

import EarthquakePerilCommercialIcon from './EarthquakePerilCommercialIcon';
import EarthquakePerilPersonalIcon from './EarthquakePerilPersonalIcon';
import FloodPerilCommercialIcon from './FloodPerilCommercialIcon';
import FloodPerilPersonalIcon from './FloodPerilPersonalIcon';

let perilIcons: Map<BroadLineOfBusiness, Map<Peril, React.ComponentType<SvgIconProps>>> = new Map([
	[BroadLineOfBusiness.PERSONAL, new Map([
		[Peril.EARTHQUAKE, EarthquakePerilPersonalIcon],
		[Peril.FLOOD, FloodPerilPersonalIcon],
	])],
	[BroadLineOfBusiness.COMMERCIAL, new Map([
		[Peril.EARTHQUAKE, EarthquakePerilCommercialIcon],
		[Peril.FLOOD, FloodPerilCommercialIcon],
	])],

]);

export default perilIcons;